module.exports = __webpack_public_path__ + "static/img/installedDMSbg.fc2e064.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/installedDMSbg.png
// module id = X5BR
// module chunks = 1